<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-09-25 09:23:56
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-21 10:26:30
 -->
<!--  -->
<template>
  <basicContainer>
    <div class="taskCenter">
      <div class="announcementManage">
        <h2 class="text-center">{{detailArray.title}}</h2>
        <p class="text-center">
          时间： {{detailArray.publish_time}}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          作者： {{detailArray.publisher_name}}
        </p>
        <div v-html="detailArray.content" class="ql-editor">
        </div>
        <div style="text-align: center;">
          <img :src="imgSrc" alt="" style="max-width: 100%">
        </div>
      </div>
    </div>
  </basicContainer>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
export default {
  components: {

  },
  data() {
    return {
      detailArray: [],
      imgSrc: ''
    }
  },

  mounted() {
    this.getAnnouncementDetail()
  },
  methods: {
    getAnnouncementDetail: function () {
      this.$http.get('/notice/readNotice', {
        params: {
          id: this.$route.query.id
        }
      }).then(response => {
        this.detailArray = response.data

        this.imgSrc = window.config.FDFS_WEB_SERVER_URL + response.data.photo
      }
      ).catch(
        error => {
          if (error.msg) { this.$message.error(error.msg) } else { this.$message.error(error.message) }
        }
      )
    }
  }
}
</script>
<style lang='scss' scoped>
:deep(.el-card) {
  background: transparent !important;
}
.announcementManage {
  // margin-top: 10px;
  // margin-bottom: 10px;
  padding: 30px;
  min-height: 500px;
  background-color: white;
}
.text-center {
  text-align: center;
}
.color_gray {
  color: #808080;
}
:deep(.ql-editor .ql-align-right) {
  text-align: right;
}
:deep(a) {
  color: #1871db;
  text-decoration: underline;
}
</style>
